import React, { useEffect, useState } from "react";
import logo from "../assets/logo.png";

import usecase from "../assets/usecase.png";
import video from "../assets/video.png";
import Pricing from "./Pricing";
// import play from "../assets/Play.mp4";
import Services from "./Services";
import ContactForm from "./ContactForm";
import PlaceHolderVid from "../assets/PlaceHolderVid.png"
import { Link } from "react-router-dom";


export default function Home() {

  useEffect(() => {
  const hash = window.location.hash;
  if (hash) {
    const el = document.querySelector(hash);
    if (el) {
      setTimeout(() => {
        el.scrollIntoView({ behavior: "smooth" });
      }, 50);
    }
  }
}, []);
  const [showPricing, setShowPricing] = useState(false);




  return (
    <div className="container">



      <section id="hero" className="mt-5 pt-4">
        {showPricing ? (
          <Pricing />
        ) : (
          <div className="row align-items-center g-5">
            <div className="col-md-6 text-center text-md-start">
              <h1 className="fw-bold display-5 mb-3">
                Websites from £19.50 per month
              </h1>

              <p className="text-muted fs-5 mb-4">
                I create and host modern websites for a simple monthly price,
                with options for mobile apps and custom systems when you need
                more.
              </p>

              <div className="d-flex justify-content-center justify-content-md-start gap-4 mt-3">
                <Link
                  to="/concept"
                  className="btn brand-purple-inline text-white"
                >
                  Start a project
                </Link>

                <a
                  href="/#pricng"
                  className="btn brand-purple-outline"
                  onClick={() => setShowPricing(true)}
                >
                  View pricing
                </a>
              </div>
            </div>

            <div className="col-md-6 text-center">
              <img
                src={usecase}
                alt="Website and mobile app illustration"
                className="img-fluid"
              />
            </div>
          </div>
        )}
      </section>

{/* <div className="text-center my-5 pt-3">
  <div className="video-wrapper">
    <video
      src={play}
      className="w-100 rounded-4"
      controls
      playsInline
      poster={PlaceHolderVid}
    ></video>
  </div>

  <p className="mt-3">
    <strong>Contact me on:</strong> Info@bordercitysoftware.com
  </p>
</div> */}


      <section className="text-center mt-5 pt-4" id="services">
        <Services />
      </section>

      <section id="contact" className="mt-5 pb-5">
        <h2 className="text-center fw-bold mb-3">Contact Me</h2>
        <p className="text-center text-muted">
          Have a project in mind? Send me a message and I will get back to you.
        </p>

   <ContactForm />
      </section>
    </div>
  );
}
